import React from "react";

import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import DataTable from "../../../components/data-table";
import FormModalContent from "./form";
import { useMemo } from "react";
import coordinationService from "../../../services/coordination.service";
import { useSelector } from "react-redux";

const defaultKeys = [
  {
    title: "شماره تلفن",
    field: "user.phoneNumber",
    active: true,
  },
];

export default function CoordinationPage() {
  const { initials } = useSelector((state) => state.app);
  const filterForm = useMemo(
    () =>
      !initials
        ? undefined
        : {
            form: [
              {
                _type: "autocomplete",
                _empty: "pending",
                name: "status",
                options: initials.enums.lensCoordinationStatus,
                valueSelector: "value",
                labelSelector: "title",
                label: "وضعیت",
                disableClearable: true,
              },
            ],
          },
    [initials]
  );

  const headerCells = useMemo(
    () => [
      {
        field: "glass",
        title: "نام عینک",
        disableSort: true,
        renderer: (v) => v.name,
      },
      {
        field: "user",
        title: "کاربر",
        disableSort: true,
        renderer: (v) => v.fullName,
      },
      {
        field: "user",
        title: "شماره تلفن",
        disableSort: true,
        renderer: (v) => <span className="en">{v.phoneNumber}</span>,
      },
      {
        field: "status",
        title: "وضعیت",
        disableSort: true,
        renderer: (v) =>
          initials?.enums?.lensCoordinationStatus?.find((s) => s.value === v)
            ?.title || v,
      },
      {
        field: "createDate",
        title: "تاریخ درخواست",
        date: true,
        // isDate
        mainField: true,
      },
      // {
      //   field: "color",
      //   title: "کد هماهنگی",
      //   renderer: (val) =>
      //     val ? (
      //       <>
      //         <span className="color-circle" style={{ backgroundColor: val }} />
      //         <span>{val}</span>
      //       </>
      //     ) : (
      //       "-"
      //     ),
      // },
      // {
      //   field: "imageUrl",
      //   title: "تصویر هماهنگی",
      //   renderer: (val) =>
      //     val ? <img className="color-circle" src={val} alt="" /> : "-",
      // },
    ],
    [initials]
  );

  return (
    <div className="p-3">
      <DataTable
        orderBy="createDate"
        headCells={headerCells}
        backend={coordinationService.getCoordinationsUrl}
        rowActions={[
          {
            modalProps: { maxWidth: "sm" },
            icon: <InfoOutlinedIcon />,
            modalContent: (props) => <FormModalContent {...props} />,
            // hidden: (row) => row.status !== "pending",
          },
        ]}
        searchKeys={defaultKeys}
        title="هماهنگی‌ها"
        filterForm={filterForm}
      />
    </div>
  );
}
